/**
 * KOPSTORM INLINE SCRIPTS
 * Consolidated from theme.liquid inline <script> blocks
 * =====================================================
 */

/* -------------------------------------------------------
   1. COUNTRY SEARCH FILTER
   ------------------------------------------------------- */
(function() {
  var input = document.getElementById('searchInput');
  if (!input) return;
  input.addEventListener('input', function() {
    var filter = this.value.toLowerCase();
    var items = document.querySelectorAll('#CountryList .dicsl');
    items.forEach(function(item) {
      var text = item.querySelector('p').textContent.toLowerCase();
      item.style.display = text.includes(filter) ? '' : 'none';
    });
  });
})();

/* -------------------------------------------------------
   2. QUANTITY PRICING UPDATER (EUR + USD unified)
   ------------------------------------------------------- */
document.addEventListener('DOMContentLoaded', function() {
  var qs = document.querySelector('.quantity-selector__input');
  if (!qs) return;
  var raw = qs.getAttribute('data-base-price');
  if (!raw) return;

  var basePrice = parseFloat(raw.replace(',', '.').replace(/[^\d.-]/g, ''));
  var currencySymbol = raw.replace(/[0-9.,\s]/g, '');
  var useDecimals = raw.indexOf(',') > -1; // EUR uses comma decimals
  var lastQty = parseInt(qs.value, 10) || 1;

  function formatPrice(price) {
    if (useDecimals) return price.toFixed(2).replace('.', ',');
    return Math.round(price).toString();
  }

  function update() {
    var qty = parseInt(qs.value, 10) || 1;
    if (qty === lastQty) return;
    lastQty = qty;
    var formatted = currencySymbol + formatPrice(basePrice * qty);
    qs.setAttribute('quantityprice', formatted);
    ['.pricings', '#cta_price', '.pricetrigger'].forEach(function(sel) {
      var el = document.querySelector(sel);
      if (el) el.textContent = formatted;
    });
  }

  new MutationObserver(function(m) {
    m.forEach(function(mut) {
      if (mut.attributeName === 'value') update();
    });
  }).observe(qs, { attributes: true, attributeFilter: ['value'] });

  qs.addEventListener('input', update);
  qs.addEventListener('change', update);
  document.querySelectorAll('.quantity-selector__button').forEach(function(btn) {
    btn.addEventListener('click', function() { setTimeout(update, 50); });
  });
  update();
});

/* -------------------------------------------------------
   3. QUANTITY SWITCHER CUSTOM ELEMENT
   ------------------------------------------------------- */
class QuantitySwitcher extends HTMLElement {
  constructor() {
    super();
    this.selectedQuantity = 2;
    this.selectedVariants = { 1: null, 2: null };
  }

  connectedCallback() {
    this.bindEvents();
    this.initializeVariants();
    this.updatePricing();
  }

  bindEvents() {
    var self = this;
    this.querySelectorAll('[data-option]').forEach(function(opt) {
      opt.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        self.selectQuantity(parseInt(e.currentTarget.dataset.option));
      });
    });
    [1, 2].forEach(function(idx) {
      self.querySelectorAll('[data-color-swatches-' + idx + '] .quantity-switcher__color-swatch').forEach(function(swatch) {
        swatch.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          self.selectColor(idx, e.currentTarget);
        });
      });
    });
  }

  initializeVariants() {
    var self = this;
    [1, 2].forEach(function(idx) {
      var s = self.querySelector('[data-color-swatches-' + idx + '] .quantity-switcher__color-swatch.selected');
      if (s) {
        self.selectedVariants[idx] = {
          id: s.dataset.variantId,
          handle: s.dataset.productHandle,
          colorName: s.dataset.colorName,
          image: s.dataset.productImage,
          title: s.dataset.productTitle
        };
      }
    });
  }

  selectQuantity(qty) {
    this.selectedQuantity = qty;
    this.querySelectorAll('[data-option]').forEach(function(o) { o.classList.remove('selected'); });
    var sel = this.querySelector('[data-option="' + qty + '"]');
    if (sel) sel.classList.add('selected');
    var s2 = this.querySelector('[data-product-selector="2"]');
    if (s2) s2.style.display = qty === 1 ? 'none' : 'block';
    this.updatePricing();
    this.dispatchEvent(new CustomEvent('quantity-switcher:changed', {
      detail: { quantity: this.selectedQuantity, variants: this.selectedVariants },
      bubbles: true
    }));
  }

  selectColor(idx, swatch) {
    this.querySelectorAll('[data-color-swatches-' + idx + '] .quantity-switcher__color-swatch').forEach(function(s) {
      s.classList.remove('selected');
    });
    swatch.classList.add('selected');
    this.selectedVariants[idx] = {
      id: swatch.dataset.variantId,
      handle: swatch.dataset.productHandle,
      colorName: swatch.dataset.colorName,
      image: swatch.dataset.productImage,
      title: swatch.dataset.productTitle
    };
    var img = this.querySelector('[data-product-image-' + idx + ']');
    var name = this.querySelector('[data-color-name-' + idx + ']');
    var title = this.querySelector('[data-product-title-' + idx + ']');
    if (img) img.src = swatch.dataset.productImage;
    if (name) name.textContent = swatch.dataset.colorName;
    if (title) title.textContent = swatch.dataset.productTitle;
    this.dispatchEvent(new CustomEvent('quantity-switcher:changed', {
      detail: { quantity: this.selectedQuantity, variants: this.selectedVariants },
      bubbles: true
    }));
  }

  updatePricing() {}

  formatMoney(amount) {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount);
  }
}
customElements.define('quantity-switcher', QuantitySwitcher);
window.QuantitySwitcher = QuantitySwitcher;

/* -------------------------------------------------------
   4. KACHING BUNDLE LABEL INJECTION
   ------------------------------------------------------- */
document.addEventListener('DOMContentLoaded', function() {
  var extraLabels = {
    '41a_': ['FREE SHIPPING', 'FREE GIFT'],
    'b5ac956f-1466-45d0-bf37-daec51ae0b6b': ['FREE SHIPPING'],
    '0d4c31f6-888a-47bf-b707-cb924111b452': ['FREE SHIPPING', 'FREE GIFT']
  };

  // Q7X2 exists in both A and B with different meaning.
  // A: "2 Sets, YOU SAVE 10%" (no free gift on the bar)        -> FREE SHIPPING
  // B: "Buy 2, Get 1 FREE"   (FREE CLEANING KIT on the bar)    -> FREE SHIPPING + FREE GIFT
  function getQ7X2Labels(bar) {
    var hasFreeGift = bar.querySelector('.kaching-bundles__free-gift');
    return hasFreeGift ? ['FREE SHIPPING', 'FREE GIFT'] : ['FREE SHIPPING'];
  }

  function inject(bar, labels) {
    var firstLine = bar.querySelector('.kaching-bundles__bar-first-line');
    if (!firstLine || firstLine.dataset.injected) return;

    var anchor = firstLine.querySelector('.kaching-bundles__bar-label')
              || firstLine.querySelector('.kaching-bundles__bar-title');
    if (!anchor) return;

    firstLine.dataset.injected = 'true';
    labels.forEach(function(text) {
      var span = document.createElement('span');
      span.className = 'kaching-bundles__bar-label';
      span.textContent = text;
      anchor.after(span);
    });
  }

  function injectLabels() {
    // Q7X2 first, with variant detection
    document.querySelectorAll('[data-deal-bar-id="Q7X2"]').forEach(function(bar) {
      inject(bar, getQ7X2Labels(bar));
    });

    // Static map for the rest
    Object.entries(extraLabels).forEach(function(entry) {
      var barId = entry[0], labels = entry[1];
      document.querySelectorAll('[data-deal-bar-id="' + barId + '"]').forEach(function(bar) {
        inject(bar, labels);
      });
    });
  }

  injectLabels();
  new MutationObserver(injectLabels).observe(document.body, { childList: true, subtree: true });
});

/* -------------------------------------------------------
   5. QUANTITY SWITCHER SWATCH LABEL TOGGLE
   ------------------------------------------------------- */
document.querySelectorAll('.quantity-switcher__option').forEach(function(option) {
  option.addEventListener('click', function() {
    var selected = option.getAttribute('data-option');
    var label = document.querySelector('.swatch-label');
    if (label) label.style.display = selected === '2' ? 'none' : '';
  });
});

/* -------------------------------------------------------
   6. NOISE REDUCTION POPUP
   ------------------------------------------------------- */
document.addEventListener('click', function(e) {
  var trigger = e.target.closest('.popup_trigger');
  if (trigger) {
    e.preventDefault();
    var popup = document.getElementById('noise-reduction-popup');
    if (popup) {
      popup.style.display = 'flex';
      requestAnimationFrame(function() { popup.classList.add('is-visible'); });
    }
  }
});
document.addEventListener('click', function(e) {
  var popup = document.getElementById('noise-reduction-popup');
  if (!popup) return;
  if (e.target.closest('.nr-popup-close') || e.target === popup) {
    popup.classList.remove('is-visible');
    setTimeout(function() { popup.style.display = 'none'; }, 250);
  }
});
document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') {
    var popup = document.getElementById('noise-reduction-popup');
    if (popup && popup.classList.contains('is-visible')) {
      popup.classList.remove('is-visible');
      setTimeout(function() { popup.style.display = 'none'; }, 250);
    }
  }
});
